export const BOARD_SIZE = 15;
export const EMPTY_CELL = 0;
export const SNEK_CELL = 1;
export const FOOD_CELL = 2;

export const HIGH_SCORES = 'high-scores';
export const RIGHT = 'right';
export const LEFT = 'left';
export const UP = 'up';
export const DOWN = 'down';
